import { isMobileDevice } from './NetworkConnectionService';

export const requiredForIndexedDbInMB = 500;

const getFreeStorageSpaceInBytes = async (): Promise<number> => {
    if (!isMobileDevice()) {
        return new Promise<number>(resolve => resolve(100 * Math.pow(10, 9)));   // resolve with 100 GB
    }
    return new Promise<number>( (resolve, reject) => {
        (window as any).cordova.exec(function(result: any) {
            if ((window.cordova as any).platformId === 'android') {
                resolve(result * 1000);
            } else {
                resolve(result);
            }
        }, function(error: any) {
            reject('Error: ' + error.toString());
        }, 'File', 'getFreeDiskSpace', []);
    });
};

export const hasRequiredSpaceInBytes = async (requiredBytes: number): Promise<boolean> => {
    if (!isMobileDevice()) {
        return true;
    }
    const freeSpace = await getFreeStorageSpaceInBytes();
    console.log('freeSpace', freeSpace);
    console.log('requiredBytes', requiredBytes);
    return (requiredBytes + (1 * Math.pow(10, 6))) < freeSpace;     // Add additional buffer of 1 MB
};